import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import { injectIntl, FormattedMessage } from 'react-intl';
import axios from 'axios';

import DateRange from '../DateRange';
import CurrencyConverter from '../../CurrencyConverter';
import BillDetails from './BillDetails';
import BookingButton from './BookingButton';
import moment from 'moment'
import TimeField from '../TimeField';
import CustomCheckbox from '../../CustomCheckbox';
import AddonsSelector from '../../Booking/AddonsSelector/AddonsSelector';

import messages from '../../../locale/messages';
import { bookingProcess } from '../../../actions/booking/bookingProcess';
import { generateTimes } from '../../../helpers/formatting';

import miniBus from '/public/siteImages/minibus.svg';

import s from './Calendar.css';
import cs from '../../../components/commonStyle.css';

class BookingForm extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    delivery: PropTypes.number,
    currency: PropTypes.string,
    monthlyDiscount: PropTypes.number,
    weeklyDiscount: PropTypes.number,
    minDay: PropTypes.number,
    maxDay: PropTypes.number,
    maxDaysNotice: PropTypes.string,
    loading: PropTypes.bool,
    availability: PropTypes.bool,
    maximumStay: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    blockedDates: PropTypes.array,
    isHost: PropTypes.bool.isRequired,
    guests: PropTypes.number,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userBanStatus: PropTypes.number,
    }),
    // New props for booking mode and hours validation
    bookingMode: PropTypes.string, // 'hourly' | 'daily' | 'both'
    minHours: PropTypes.number,
    maxHours: PropTypes.number,
    timeZone: PropTypes.string,
  };

  constructor(props) {
    super(props);
    // Initialize isSingleDate based on bookingMode
    // isSingleDate: false = Hourly mode, true = Daily mode
    const initialMode = props.bookingMode === 'daily' ? true : false;
    this.state = {
      includeDelivery: false,
      isSingleDate: initialMode,
      reservedSlots: [],
      isLoadingReservedSlots: false,
      listingAddons: [],
      selectedAddons: {},
    }
  }

  static defaultProps = {
    blockedDates: [],
    availability: true,
    maximumStay: false,
    minimumStay: false,
    startDate: null,
    endDate: null,
    guests: 1,
    personCapacity: 0,
  };

  componentDidMount() {
    const { URLRoomType, roomType, change } = this.props;
    this.setState({ includeDelivery: URLRoomType == "true" ? true : false })
    change('roomType', URLRoomType == "true" ? true : false)
    this.fetchReservedSlots();
    this.fetchListingAddons();
  }

  fetchReservedSlots = async () => {
    const { id } = this.props;
    this.setState({ isLoadingReservedSlots: true });

    try {
      const response = await axios.get(`/web-api/list-reservations?listId=${id}&includeHourly=true`);
      if (response.data && response.data.success) {
        console.log("🚀 ~ BookingForm ~ fetchReservedSlots= ~ reservations:", response.data.reservations)
        this.setState({
          reservedSlots: response.data.reservations,
          isLoadingReservedSlots: false
        });
      }
    } catch (error) {
      console.error('Error fetching reserved slots:', error);
      this.setState({
        reservedSlots: [],
        isLoadingReservedSlots: false
      });
    }
  };

  fetchListingAddons = async () => {
    const { id } = this.props;
    try {
      const response = await axios.post('/graphql', {
        query: `query getListingAddons($listId: Int!) {
          getListingAddons(listId: $listId) {
            id
            name
            description
            price
            priceType
          }
        }`,
        variables: { listId: id }
      });
      if (response.data?.data?.getListingAddons) {
        this.setState({ listingAddons: response.data.data.getListingAddons });
      }
    } catch (error) {
      console.error('Error fetching listing addons:', error);
    }
  };

  renderFormControlSelect({ input, label, meta: { touched, error }, children, className }) {
    return (
      <div className={'inputFocusColor'}>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    );
  }

  renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;
    const rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</option>);
    }
    return rows;
  }

  handleCheckBox = (event) => {
    const { change } = this.props;
    const { includeDelivery } = this.state;
    this.setState({ includeDelivery: !includeDelivery });
    change('roomType', event);
  }
  checkboxHorizontalGroup = ({ label, labelSmall }) => {
    const { delivery, currency, roomType } = this.props

    return (
      <div className={s.doorStepSection}>
        <div className={cx(s.doorStepImageSection, cs.displayFlex, cs.alignCenter, 'doorStepImageRTL')}>
          <img src={miniBus} className={s.doorStepImage} />
        </div>
        <div className={cx(s.doorStepText, 'doorStepRTL')}>
          <div>
            <p className={cs.commonMediumText}>{label}</p>
            <p className={cx(cs.commonSmallText, cs.siteLinkColor)}>({labelSmall}{' '}-{' '}{<CurrencyConverter amount={delivery} from={currency} />})</p>
          </div>
          <CustomCheckbox
            className={'icheckbox_square-green'}
            onChange={event => {
              this.handleCheckBox(event);
            }}
            checked={roomType}
            value={true}
          />
        </div>
      </div>
    )
  };

  handleDateCheckBox = (eventOrChecked) => {
    const checked = eventOrChecked && eventOrChecked.target
      ? eventOrChecked.target.checked
      : eventOrChecked;

    this.setState({ isSingleDate: checked });

    // sync to redux-form if needed
    const { change } = this.props;
    change('isSingleDate', checked);
  };


  render() {
    const { includeDelivery, reservedSlots, isLoadingReservedSlots } = this.state;
    const { formatMessage } = this.props.intl;
    const { id, basePrice, hourlyPrice, delivery, currency, isHost, bookingType, personCapacity, odometerCapacity } = this.props;
    const { monthlyDiscount, weeklyDiscount, minDay, maxDay, maxDaysNotice, securityDeposit } = this.props;
    const { isLoading, availability, maximumStay, guests, startDate, endDate, account, blockedDates, minimumStay } = this.props;
    const { bookingProcess, serviceFees, base, rates, bookingLoading, startTime, endTime } = this.props;
    const { roomType, bookingLoader } = this.props;
    const isDateChosen = startDate != null && (this.state.isSingleDate ? endDate : true)
    let userBanStatusValue, deliveryFee, deliveryStatus, isTimeChosen;
    let momentStartDate, momentEndDate, dayDifference, isDisabled = false, isValue = true;
    let isToday = false, startTimeLookup, endTimeLookup;

    if (account) {
      const { account: { userBanStatus } } = this.props;
      userBanStatusValue = userBanStatus;
    }

    if (includeDelivery) {
      deliveryFee = delivery
      deliveryStatus = 'include'
    } else {
      deliveryFee = 0
      deliveryStatus = 'exclude'
    }

    momentStartDate = moment(startDate);
    momentEndDate = moment(endDate);
    dayDifference = momentEndDate.diff(momentStartDate, 'days');

    isTimeChosen = isNaN(startTime) || isNaN(endTime) ? false : true;

    // Calculate total hours (supports crossing midnight)
    // NOTE: startTime and endTime are in DECIMAL HOURS (e.g., 23 = 11PM, 0.5 = 12:30AM)
    let totalHours = 0;
    let crossesMidnight = false;
    if (isTimeChosen && !this.state.isSingleDate) {
      if (endTime > startTime) {
        // Same day booking (e.g., 9AM to 5PM = 17 - 9 = 8 hours)
        totalHours = endTime - startTime;
      } else if (endTime < startTime) {
        // Crosses midnight (e.g., 11PM to 1AM = (24-23) + 1 = 2 hours)
        totalHours = (24 - startTime) + endTime;
        crossesMidnight = true;
      } else {
        // Same time = invalid
        totalHours = 0;
      }
    }

    // Validate minHours/maxHours
    const { minHours, maxHours } = this.props;
    let hoursValidationError = null;
    if (isTimeChosen && !this.state.isSingleDate && totalHours > 0) {
      if (minHours && totalHours < minHours) {
        hoursValidationError = 'minHours';
        isDisabled = true;
      } else if (maxHours && maxHours > 0 && totalHours > maxHours) {
        hoursValidationError = 'maxHours';
        isDisabled = true;
      }
    }

    // Validate overlap with existing reservations
    let hasOverlap = false;
    if (isTimeChosen && !this.state.isSingleDate && startDate && reservedSlots && reservedSlots.length > 0) {
      const selectedDateStr = moment(startDate).format('YYYY-MM-DD');
      const nextDayStr = moment(startDate).add(1, 'day').format('YYYY-MM-DD');
      const newStart = parseFloat(startTime);
      const newEnd = parseFloat(endTime);
      const newCrossesMidnight = newEnd < newStart;

      reservedSlots.forEach(slot => {
        if (hasOverlap) return; // Already found overlap

        const slotDateStr = moment(slot.checkIn).format('YYYY-MM-DD');
        const slotStart = parseFloat(slot.startTime);
        const slotEnd = parseFloat(slot.endTime);
        const slotCrossesMidnight = slotEnd < slotStart;

        // Same day reservations
        if (slotDateStr === selectedDateStr) {
          if (!newCrossesMidnight && !slotCrossesMidnight) {
            // Both same day: check simple overlap
            if (newStart < slotEnd && newEnd > slotStart) {
              hasOverlap = true;
            }
          } else if (newCrossesMidnight && !slotCrossesMidnight) {
            // New crosses midnight, slot is same day
            // New booking starts before slot ends
            if (newStart < slotEnd) {
              hasOverlap = true;
            }
          } else if (!newCrossesMidnight && slotCrossesMidnight) {
            // Slot crosses midnight, new is same day
            // New booking ends after slot starts
            if (newEnd > slotStart) {
              hasOverlap = true;
            }
          }
        }

        // Next day reservations (for midnight crossing)
        if (newCrossesMidnight && slotDateStr === nextDayStr) {
          // New booking ends next day, check if it overlaps with slot that starts on next day
          if (newEnd > slotStart) {
            hasOverlap = true;
          }
        }
      });

      if (hasOverlap) {
        isDisabled = true;
      }
    }

    // Only disable if same day and endTime <= startTime AND not crossing midnight intentionally
    // We now allow endTime < startTime to indicate next day
    if (startTime === endTime && dayDifference === 0 && !this.state.isSingleDate) {
      isValue = false;
      isDisabled = true;
    }
    if (!this.state.isSingleDate && !isTimeChosen) {
      isDisabled = true;
    } else if (this.state.isSingleDate && !isDateChosen) {
      isDisabled = true;
    }

    startTimeLookup = generateTimes(0, 1410, isToday);
    endTimeLookup = generateTimes(0, 0);

    if (momentStartDate) {
      isToday = moment(moment(momentStartDate)).isSame(moment(), 'day');
      startTimeLookup = generateTimes(0, 1410, isToday);
    }

    if (momentEndDate) {
      isToday = moment(moment(momentEndDate)).isSame(moment(), 'day');
      endTimeLookup = generateTimes(0, 0, isToday);
    }

    // SMART FILTER: Remove irrelevant past hours but ALLOW midnight crossing
    // This applies even when there are no reservations to prevent UX confusion
    if (!isNaN(startTime) && startTime !== null && startTime !== '' && !this.state.isSingleDate) {
      const startTimeFloat = parseFloat(startTime);
      const minGap = 0.5; // Minimum 30 minutes between start and end

      // First, filter to get valid options
      let sameDayOptions = [];
      let nextDayOptions = [];

      endTimeLookup.forEach(item => {
        const itemValue = parseFloat(item.value);

        // Case 1: Normal - endTime is greater than startTime + minGap (same day)
        // Example: Start 20:00 (8PM) -> End must be >= 20:30 (8:30PM)
        if (itemValue >= startTimeFloat + minGap) {
          sameDayOptions.push({ ...item, isNextDay: false });
        }

        // Case 2: Midnight Crossing - startTime is late night, endTime is early morning
        // Example: Start 22:00 -> End 02:00 (next day)
        // We allow this when start is evening (>= 18:00) and end is morning (< 12:00)
        else if (startTimeFloat >= 18.0 && itemValue < 12.0) {
          // Mark as next day and update label
          const newLabel = item.label + ' (+1)';
          nextDayOptions.push({ ...item, label: newLabel, isNextDay: true });
        }
      });

      // Combine: same day options first, then next day options
      endTimeLookup = [...sameDayOptions, ...nextDayOptions];
    }

    // ADVANCED FILTER: Prevent overlap with existing reservations (cut-off logic)
    // THE CUT-OFF: Find the first reservation after startTime and limit endTime options to before it
    if (!isNaN(startTime) && startDate && reservedSlots && reservedSlots.length > 0 && !this.state.isSingleDate) {
      const selectedDateStr = moment(startDate).format('YYYY-MM-DD');
      const prevDayStr = moment(startDate).subtract(1, 'day').format('YYYY-MM-DD');
      const nextDayStr = moment(startDate).add(1, 'day').format('YYYY-MM-DD');
      const startTimeFloat = parseFloat(startTime);

      // Find the FIRST blocking reservation after our startTime (the cut-off point)
      let sameDayCutoff = null; // Cut-off for same-day bookings (endTime > startTime)
      let nextDayCutoff = null; // Cut-off for midnight-crossing bookings (endTime < startTime)

      reservedSlots.forEach(slot => {
        if (!slot.isHourly) return; // Skip daily reservations (they block the whole day)

        const slotDateStr = moment(slot.checkIn).format('YYYY-MM-DD');
        const slotStart = parseFloat(slot.startTime);
        const slotEnd = parseFloat(slot.endTime);
        const slotCrossesMidnight = slotEnd < slotStart;

        // Same day: find the EARLIEST reservation that starts AFTER our startTime
        // This is the cut-off point - user cannot select endTime beyond this
        if (slotDateStr === selectedDateStr && slotStart > startTimeFloat) {
          if (sameDayCutoff === null || slotStart < sameDayCutoff) {
            sameDayCutoff = slotStart;
          }
        }

        // Same day: if slot crosses midnight and starts after our startTime
        if (slotDateStr === selectedDateStr && slotCrossesMidnight && slotStart > startTimeFloat) {
          if (sameDayCutoff === null || slotStart < sameDayCutoff) {
            sameDayCutoff = slotStart;
          }
        }

        // Next day: for midnight-crossing bookings, find earliest reservation on next day
        if (slotDateStr === nextDayStr && !slotCrossesMidnight) {
          if (nextDayCutoff === null || slotStart < nextDayCutoff) {
            nextDayCutoff = slotStart;
          }
        }

        // Previous day: if a reservation from yesterday crosses midnight into today,
        // it might affect early morning selections (already handled in startTime disabled)
      });

      // Filter endTimeLookup: ONLY show options up to (but not including) the cut-off
      endTimeLookup = endTimeLookup.filter(item => {
        const itemValue = parseFloat(item.value);

        // Same day booking (not marked as next day)
        if (!item.isNextDay) {
          // Cut-off: user can select UP TO the cut-off point (not beyond)
          if (sameDayCutoff !== null && itemValue > sameDayCutoff) {
            return false;
          }
          return true;
        }

        // Next day options (midnight crossing)
        if (item.isNextDay) {
          // If there's a cut-off on next day, limit selections
          if (nextDayCutoff !== null && itemValue > nextDayCutoff) {
            return false;
          }
          // Also check if there's a same-day reservation that blocks midnight crossing
          // If sameDayCutoff exists, don't allow crossing midnight at all
          if (sameDayCutoff !== null) {
            return false;
          }
          return true;
        }

        return true;
      });
    }

    return (
      <Form>
        <FormGroup className={cs.spaceBottom4}>
          <div className={`${cs.displayFlex} ${cs.alignCenter} ${cs.spaceBetween}`}>
            <label>
              <FormattedMessage {...messages.dates} />
            </label>
            <div className={cs.displayFlex}>
              {/* Only show toggle if bookingMode is 'both' or undefined */}
              {(this.props.bookingMode === 'both' || !this.props.bookingMode) && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px',
                  marginTop: '0px',
                  position: 'relative'
                }}>
                  <div style={{
                    display: 'flex',
                    width: '120px',
                    height: '30px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '15px',
                    position: 'relative',
                    cursor: 'pointer'
                  }} onClick={() => this.setState({ isSingleDate: !this.state.isSingleDate })}>
                    {/* Hourly Text */}
                    <span style={{
                      position: 'absolute',
                      left: '15px',
                      top: '7px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: this.state.isSingleDate ? '#666' : '#fff',
                      transition: 'all 0.3s ease',
                      zIndex: 3
                    }}>
                      {formatMessage(messages.hourlyLabel)}
                    </span>
                    {/* Daily Text */}
                    <span style={{
                      position: 'absolute',
                      right: '15px',
                      top: '7px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: this.state.isSingleDate ? '#fff' : '#666',
                      transition: 'all 0.3s ease',
                      zIndex: 3
                    }}>
                      {formatMessage(messages.dailyLabel)}
                    </span>
                    <div style={{
                      position: 'absolute',
                      width: '60px',
                      height: '26px',
                      backgroundColor: '#4CAF50',
                      borderRadius: '13px',
                      top: '2px',
                      left: this.state.isSingleDate ? '58px' : '2px',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      zIndex: 2
                    }} />
                  </div>
                </div>
              )}
              {/* Show fixed mode indicator when bookingMode is not 'both' */}
              {this.props.bookingMode && this.props.bookingMode !== 'both' && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px',
                  marginTop: '0px',
                  padding: '6px 16px',
                  backgroundColor: '#4CAF50',
                  borderRadius: '15px',
                  color: '#fff',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {this.props.bookingMode === 'hourly' ? formatMessage(messages.hourlyLabel) : formatMessage(messages.dailyLabel)}
                </div>
              )}
            </div>
          </div>
          <span className={cx('viewListingDate')}>
            <DateRange
              key={this.state.isSingleDate ? 'hourly' : 'daily'}
              isSingleDate={this.state.isSingleDate}
              listId={id}
              minimumNights={minDay}
              maximumNights={maxDay}
              blockedDates={blockedDates}
              formName="BookingForm"
              maxDaysNotice={maxDaysNotice}
              startTime={startTime}
              endTime={endTime}
              reservedSlots={reservedSlots}
            />
          </span>
        </FormGroup>
        {/* time field */}
        {
          !this.state.isSingleDate &&
          <FormGroup className={cs.spaceBottom4}>
            <label>{formatMessage(messages.startLabel)}</label>
            <div className={s.displayGrid}>
              <TimeField
                name={"startTime"}
                className={cs.formControlSelect}
                TimeLookup={startTimeLookup}
                formName={"BookingForm"}
                label={formatMessage(messages.tripStart)}
                listId={id}
                startDate={startDate}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
                maximumNights={maxDay}
                value={startTime}
                minimumNights={minDay}
                classNameParent={cx(s.paddingRight, 'calendarPaddingRightRTL')}
                reservedSlots={reservedSlots}
              />
              <TimeField
                name={"endTime"}
                className={cs.formControlSelect}
                TimeLookup={endTimeLookup}
                formName={"BookingForm"}
                label={formatMessage(messages.tripEnd)}
                listId={id}
                startDate={startDate}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
                maximumNights={maxDay}
                value={endTime}
                minimumNights={minDay}
                classNameParent={cx(s.paddingLeft, 'calendarPaddingLeftRTL')}
                reservedSlots={reservedSlots}
              />
            </div>
          </FormGroup>
        }

        {
          (delivery != null || delivery != undefined) && Number(delivery) > 0 &&
          <FormGroup className={cs.spaceBottom3}>
            <Field
              name="roomType"
              component={this.checkboxHorizontalGroup}
              label={formatMessage(messages.doorstepDelivery)}
              labelSmall={formatMessage(messages.deliveryCharges)}
            />
          </FormGroup>
        }
        <FormGroup>
          {
            !isLoading && maximumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumStay} /> {maxDay} {maxDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }
          {
            !isLoading && minimumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumStayText} /> {minDay} {minDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }

          {
            !isLoading && !availability && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.hostErrorMessage2} />
              </p>
            </div>
          }
          {
            isTimeChosen && !isValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}><FormattedMessage {...messages.youMustChooseTime} /></p>
            </div>
          }
          {/* Hours validation errors */}
          {
            hoursValidationError === 'minHours' && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumHoursError} /> {minHours} {minHours > 1 ? formatMessage(messages.hoursLabel) : formatMessage(messages.hourLabel)}
              </p>
            </div>
          }
          {
            hoursValidationError === 'maxHours' && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumHoursError} /> {maxHours} {maxHours > 1 ? formatMessage(messages.hoursLabel) : formatMessage(messages.hourLabel)}
              </p>
            </div>
          }
          {/* Show overlap error */}
          {
            hasOverlap && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.overlapError} />
              </p>
            </div>
          }
          {/* Show indicator when booking crosses midnight */}
          {
            crossesMidnight && isTimeChosen && !this.state.isSingleDate && <div className={cx(s.bookItMessage, cs.spaceTop1)} style={{ backgroundColor: '#e3f2fd', borderColor: '#2196F3' }}>
              <p className={cx(s.noMargin, s.textCenter)} style={{ color: '#1565C0' }}>
                <FormattedMessage {...messages.crossesMidnight} /> ({totalHours.toFixed(1)} {formatMessage(messages.hoursLabel)})
              </p>
            </div>
          }
        </FormGroup>
        {/* Add-ons Selector */}
        {
          this.state.listingAddons.length > 0 && isDateChosen && !userBanStatusValue && (
            <AddonsSelector
              addons={this.state.listingAddons}
              selectedAddons={this.state.selectedAddons}
              onChange={(selected) => this.setState({ selectedAddons: selected })}
              guests={odometerCapacity || personCapacity || 12}
              currency={currency}
            />
          )
        }
        {
          !bookingLoader && !maximumStay && !minimumStay && availability && isDateChosen && !userBanStatusValue && (this.state.isSingleDate ? true : isTimeChosen) && isValue && !hoursValidationError && !hasOverlap && (() => {
            // Calculate addons total
            const addonsTotal = this.state.listingAddons.reduce((sum, addon) => {
              const qty = this.state.selectedAddons[addon.id] || 0;
              return sum + (addon.price * qty);
            }, 0);
            return <BillDetails
              basePrice={basePrice}
              hourlyPrice={hourlyPrice}
              delivery={deliveryFee}
              currency={currency}
              monthlyDiscount={monthlyDiscount}
              weeklyDiscount={weeklyDiscount}
              startDate={startDate}
              endDate={endDate}
              startTime={startTime}
              endTime={endTime}
              bookingType={this.state.isSingleDate}
              serviceFees={serviceFees}
              base={base}
              rates={rates}
              securityDeposit={securityDeposit}
              crossesMidnight={crossesMidnight}
              totalHours={totalHours}
              addonsTotal={addonsTotal}
            />;
          })()
        }
        <BookingButton
          listId={id}
          startDate={startDate}
          endDate={endDate}
          guests={!isNaN(guests) ? guests : 1}
          bookingProcess={bookingProcess}
          availability={availability}
          isDateChosen={isDateChosen}
          userBanStatus={userBanStatusValue}
          basePrice={basePrice}
          hourlyPrice={hourlyPrice}
          isSingleDate={this.state.isSingleDate}
          isHost={isHost}
          bookingType={bookingType}
          bookingLoading={bookingLoading}
          maximumStay={maximumStay}
          isDisabled={isDisabled}
          startTime={startTime}
          endTime={endTime}
          deliveryStatus={deliveryStatus}
          roomType={roomType}
          selectedAddons={this.state.selectedAddons}
          listingAddons={this.state.listingAddons}
        />
      </Form>
    );
  }
}
BookingForm = reduxForm({
  form: 'BookingForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(BookingForm);

const selector = formValueSelector('BookingForm');

const mapState = state => ({
  isLoading: state?.viewListing?.isLoading,
  availability: state?.viewListing?.availability,
  maximumStay: state?.viewListing?.maximumStay,
  minimumStay: state?.viewListing?.minimumStay,
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  guests: Number(selector(state, 'guests')),
  account: state?.account?.data,
  serviceFees: state?.book?.serviceFees,
  base: state?.currency?.base,
  rates: state?.currency?.rates,
  bookingLoading: state?.book?.bookingLoading,
  startTime: Number(selector(state, 'startTime')),
  endTime: Number(selector(state, 'endTime')),
  roomType: selector(state, 'roomType')
});
const mapDispatch = {
  bookingProcess,
};
export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(BookingForm)));